export enum ModalState {
	CLOSE,
	DEFAULT,
	OPEN,
}
export type ModalStatus = {
	similarModal: ModalState;
	contactLead: ModalState;
};
